import React from 'react'
import PropTypes from 'prop-types'
import HashAnchor from '../HashAnchor/HashAnchor'

const PrivacyPolicyDE = ({ mobile = true }) => {
  return (
    <>
      <h2>Lifesum/Movesum Datenschutzerklärung</h2>
      <p>
        Indem Sie unsere mobile Anwendung installieren oder auf andere Art und
        Weise auf unsere Dienste zugreifen, akzeptieren Sie die Bedingungen
        dieser Datenschutzerklärung und die Verarbeitung Ihrer personenbezogenen
        Daten.
      </p>

      <h3>Verantwortlicher für personenbezogene Daten</h3>

      <p>
        Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten ist:
      </p>

      <dl>
        <dt>Firmenbezeichnung</dt>
        <dd>Lifesum AB</dd>

        <dt>Organisationsnummer</dt>
        <dd>556729-2841</dd>

        <dt>Adresse</dt>
        <dd>
          Repslagargatan 17B, <br />
          118 46 Stockholm, Schweden
        </dd>

        <dt>E-mail</dt>
        <dd>
          {mobile && 'contact@lifesum.com'}
          {!mobile && (
            <a href="mailto:contact@lifesum.com">contact@lifesum.com</a>
          )}
        </dd>
      </dl>

      <h3>Welche personenbezogenen Daten wir erheben</h3>

      <p>
        Wenn Sie sich für die Dienste von Lifesum anmelden, erheben wir von
        Ihnen personenbezogene Daten, wie z.B.: Ihre E-Mail-Adresse, Vor- und
        Nachname, Größe, Gewicht, Geburtsdatum und Geschlecht.
      </p>
      <p>
        Wenn Sie die Dienste von Lifesum weiter in Anspruch nehmen, werden Sie
        regelmäßig personenbezogene Daten auf Ihr Konto hochladen, wie z.B. Ihre
        Kalorienzufuhr, Wunschgewichtsziele, Bewegungs-/Diätprogramm, Ihre
        Körpermaße und BMI – je nachdem wie Sie die Dienste benutzen.
      </p>
      <p>
        Um unsere Dienste kontinuierlich zu verbessern, werden möglicherweise
        weitere personenbezogene Daten von Ihnen erhoben. In solchen Fällen
        werden wir Sie darauf hinweisen, wenn die Erhebung von personenbezogenen
        Daten stattfindet.
      </p>

      <h3>Unsere Nutzung Ihrer personenbezogenen Daten</h3>
      <p>
        Ihre Privatsphäre ist uns wichtig. Wir werden Ihre personenbezogenen
        Daten ausschließlich gemäß den Vorgaben dieser Datenschutzerklärung und
        den einschlägigen Regelungen zum Schutz personenbezogener Daten
        (Datenschutzvorschriften) verarbeiten.
      </p>

      <h3>Datenverarbeitung ist erforderlich um Dienste anzubieten</h3>
      <p>
        Als Bestandteil unseres Dienstleistungsangebotes an Sie, verarbeiten wir
        die personenbezogenen Daten, die Sie uns bei der Anmeldung zur Verfügung
        stellen, z.B.:
      </p>
      <ul>
        <li>Vor- und Nachname</li>
        <li>E-Mail-Adresse</li>
        <li>Geburtsdatum</li>
        <li>Land in dem Ihr Wohnort liegt</li>
        <li>Gewicht</li>
        <li>Größe</li>
        <li>
          Gerätekennung, d.h. Informationen über Gerät, IP-Adresse etc. mit dem
          Sie sich für die Dienste anmelden und einloggen.
        </li>
      </ul>

      <p>
        Wenn Sie die Dienste weiter in Anspruch nehmen, werden Sie regelmäßig
        weitere personenbezogene Daten an Lifesum übermitteln. Es liegt in der
        Natur unseres Angebotes, dass wir die Daten, die Sie im Rahmen unserer
        Dienste hochladen, zur Erbringung dieser Dienste verarbeiten müssen. Wir
        werden z.B. Ihre Gewichtsdaten und Kalorienzufuhr verarbeiten, um die
        Überwachung und Darstellung Ihrer persönlichen Ziele (Gewichtsabnahme
        oder -zunahme) zu ermöglichen. Diese Art von Verarbeitung ist eine
        Voraussetzung dafür, Ihnen diese Dienste anbieten zu können.
      </p>
      <p>
        Wenn Sie auf unseren Dienst über eine Drittanwendung zugreifen (z.B.
        Apple HealthKit, Facebook), wird Lifesum personenbezogene Daten von
        solchen Drittanwendungen erheben und nutzen, so z.B. Ihren Nutzernamen,
        Namen, Profilbild, Land, Wohnort, E-Mail-Adresse, Geburtsdatum,
        Geschlecht und solche Gesundheitsinformationen, die Sie mit den Lifesum
        Diensten synchronisieren.
      </p>
      <p>
        Einige der oben genannten Daten, die von Ihnen erhoben und durch Lifesum
        für bestimmte Dienstfunktionen verarbeitet werden, können wir löschen,
        wenn Sie dies wünschen, und in Zukunft von der Verarbeitung absehen,
        ohne dass Sie die Nutzung aller Dienste beenden müssen; nicht alle Daten
        (die Sie uns im Laufe der Zeit direkt oder über Drittanwendungen
        übermitteln) werden benötigt, damit Sie weiterhin die Dienste nutzen
        können. Wenn Sie wünschen, dass wir die Verarbeitung bestimmter
        personenbezogenen Daten dieser Kategorie einstellen, werden wir Sie über
        die Folgen dieser Einstellung, d.h. wie sie sich auf Ihre Nutzung
        bestimmter Funktionen der Dienste auswirkt, informieren.
      </p>

      <h3>Kundenbeziehung als Rechtsgrundlage</h3>
      <p>
        Auf der Basis Ihrer Kundenbeziehung als Rechtsgrundlage für die
        Verarbeitung personenbezogener Daten wird darauf hingewiesen, dass eine
        Einwilligung für das Zusenden von Werbung durch Lifesum nicht
        erforderlich ist. Solche Daten werden gemäß den Datenschutzvorschriften
        verarbeitet und genutzt.
      </p>

      <h3>Profiling</h3>
      <p>
        Die Dienste von Lifesum beruhen auf weitreichenden Kenntnissen bewährter
        Methoden in Bezug auf die Gesundheit. Lifesum arbeitet mit
        Ernährungswissenschaftlern, Verhaltenspsychologen, Personal Trainern und
        Stress-Experten zusammen, um über die Erkenntnisse der Forschung und
        Wissenschaft auf dem neusten Stand zu bleiben. Außerdem analysiert
        Lifesum wie unser Angebot genutzt wird, um Ihnen als Nutzer
        Dienstfunktionen zur Verfügung zu stellen, die so relevant wie möglich
        in Bezug auf Ihre persönlichen Ziele sind. Durch die Analyse der Nutzung
        der Dienste, wird Lifesum bestimmte Daten für sogenanntes Profiling
        verarbeiten. Profiling heißt, dass bestimmte personenbezogene Daten
        Ihrer Person und anderer verarbeitet werden, um bestimmte Aspekte Ihrer
        Nutzung der Dienste, Ihres Verhaltens und den Ort, an dem Sie sich
        befinden, zum Zweck der Erreichung Ihrer gesundheitlichen Ziele zu
        analysieren oder vorhersagen. Bei den verarbeiteten Daten handelt es
        sich um Nutzergewohnheiten; wir werden Ihre Aktivitäten tracken, z.B.
        wie Sie zwischen den Fenstern wechseln, Schaltflächen drücken und
        Aktionen bei den Diensten ausführen. Der Zweck des Profilings ist es, zu
        überwachen wie sehr sich die Nutzer für unterschiedliche Funktionen
        unserer Dienste interessieren, Wege zu finden, unsere Dienste effektiver
        (zweckgeeigneter) zu gestalten und Funktionen und Inhalte zu variieren,
        damit sie besser zu Ihrem Nutzungsverhalten und Ihren Vorlieben passen.
      </p>
      <p>
        Die Erstellung eines Profils aus Ihren Daten kann auch als Grundlage für
        Werbung, die an neue potenziellen Kunden auf anderen Plattformen
        außerhalb der LIFESUM Dienste gerichtet ist, dienen, z.B. die
        Plattformen anderer sozialen Medien. Dieses sog. „look-a-like“
        Verfahren, mit dem neue Kunden gewonnen werden, führt nicht dazu, dass
        Sie Werbung erhalten. Es führt auch nicht dazu, dass Dritte Zugang zu
        Ihren Daten für irgendwelche Zwecke erhalten, außer damit LIFESUM neue
        Kunden erreicht. Drittanbieter (z.B. soziale Medien) werden Ihre Daten
        daher nur als Auftragsverarbeiter im Auftrag von LIFESUM verarbeiten.
        Weitere Informationen dazu finden Sie unten unter dem Punkt
        Datenübermittlung.
      </p>
      <p>
        Die oben beschriebene Verarbeitung Ihrer personenbezogenen Daten durch
        Lifesum erfordert als Rechtsgrundlage der Verarbeitung keine
        Einwilligung. Sollte dies doch der Fall sein, d.h. wenn eine
        Einwilligung nach den einschlägigen Datenschutzvorschriften für die oben
        beschriebene Nutzung erforderlich ist, erteilen Sie hiermit Ihre
        Einwilligung in die Nutzung Ihrer personenbezogenen Daten im Rahmen des
        oben beschriebenen Profilings, zum Zweck der Verbesserung der Dienste
        und zur Kundenbetreuung.
      </p>

      <h3>
        Werbung – Datenverarbeitung auf Grundlage einer Einwilligung als
        Rechtsgrundlage
      </h3>
      <p>
        Lifesum kann Ihre Einwilligung in die Nutzung aller Ihrer
        personenbezogenen Daten für Profiling- und Werbezwecke mittels E-Mail,
        Benachrichtigungen oder andere Mitteilungen durch Lifesum oder die
        ausgewählten Geschäftspartner von Lifesum verwenden.
      </p>
      <p>
        Profiling wird zu Werbezwecken genutzt, um Ihnen personalisierte und
        relevante Angebote auf der Basis Ihrer Vorlieben machen zu können, siehe
        oben unter dem Punkt Profiling.
      </p>
      <p>
        ie Verwendung personenbezogener Daten für Marketingzwecke betrifft nur
        solche Angebote, die in engem Zusammenhang mit Ihrer Nutzung des Service
        stehen. Diese Angebote werden Ihnen von Lifesum zugesendet. Keine
        personenbezogenen Daten werden zu Marketingzwecken an Dritte
        weitergegeben. Diese Verarbeitung basiert auf einem berechtigten
        Interesse, auf unserer Seite das Interesse, Ihnen den bestmöglichen
        Service zu bieten, auf Ihrer Seite die Möglichkeit, relevante Produkte
        und Dienstleistungen angeboten zu bekommen, die für Ihre Nutzung des
        Service relevant sind und für Dritte, um Sie mit solchen Angeboten zu
        erreichen. Mit anderen Worten, wir sind der Meinung, dass eine
        Zustimmung nicht erforderlich ist. Sollte dies der Fall sein, d. H. wenn
        gemäß den einschlägigen Bestimmungen für personenbezogene Daten eine
        Zustimmung für die oben beschriebene Verwendung erforderlich ist,
        stimmen Sie hiermit zu, dass wir Ihre personenbezogenen Daten wie oben
        definiert verwenden.
      </p>

      <h3>Opt-out in Bezug auf Werbung</h3>
      <p>
        Wenn Sie verhindern wollen, dass Lifesum Ihre persönlichen Daten für
        Werbezwecke nutzt, können Sie jederzeit den Abmeldelink am unteren Ende
        einer solchen Nachricht klicken oder die „opt-out“ Funktionen nutzen,
        die unter den Anwendungseinstellungen bei den Diensten verfügbar sind.
      </p>

      <HashAnchor use="h3" id="cookies">
        Cookies
      </HashAnchor>
      <p>
        Lifesum nutzt Cookies für seine ordnungsgemäße Funktionsweise. Wir
        nutzen sowohl sog. Session Cookies (die automatisch erlöschen, sobald
        der Browser geschlossen wird) als auch sog. Persistent Cookies (diese
        verbleiben auf Ihrem Gerät für eine bestimmte Zeitspanne oder bis sie
        gelöscht werden).
      </p>
      <p>
        Wenn Ihr Browser so eingerichtet ist, dass er Cookies akzeptiert,
        willigen Sie damit in die Nutzung von Cookies ein.
      </p>
      <p>
        Ein Cookie ist eine kleine Textdatei, die von den Webseiten, die Sie
        besuchen, erstellt wird und ggf. Informationen über Sie als Besucher
        enthält. Diese Textdateien werden auf Ihrem Rechner gespeichert, damit
        Sie beispielsweise Ihr Passwort nicht merken müssen. Die von Cookies
        gelieferten Informationen können ggf. genutzt werden, um das
        Nutzererlebnis und/oder die Dienste zu verbessern sowie um gezielte
        Werbekampagnen und Angebote an unsere Kunden zu richten.
      </p>
      <p>
        Wenn Sie Cookies nicht akzeptieren wollen, können Sie die Einstellungen
        an Ihrem Browser verändern, damit Cookies nicht auf Ihrem Rechner
        gespeichert werden. Sie können auch Cookies löschen, die zuvor auf Ihrem
        Rechner gespeichert wurden. Für solche Fälle wird auf den Hilfebereich
        Ihres Browsers verwiesen. Wenn Sie Cookies nicht akzeptieren, können Sie
        dennoch unsere Dienste nutzen, die Funktionalität könnte aber etwas
        eingeschränkt sein.
      </p>

      <h3>Zugriff, Berichtigung und Löschung personenbezogener Daten</h3>
      <p>
        Sie haben das Recht, den Zugriff auf Ihre von Lifesum verarbeiteten
        personenbezogenen Daten sowie deren Berichtigung oder Löschung zu
        verlangen. Sollten Sie dieses Recht ausüben wollen, kontaktieren Sie uns
        bitte unter https://lifesum.com/contact. Es muss ein schriftlicher
        Antrag erfolgen, der von Ihnen zu unterschreiben ist. Sie können Ihre
        personenbezogenen Daten aber auch löschen, indem Sie Ihr Konto über die
        Dienste löschen.
      </p>
      <p>
        Wenn sich ein Antrag auf Löschung auf Daten bezieht die für die von
        Lifesum angebotenen Dienste erforderlich sind, werden solche Anträge
        dazu führen, dass Ihr Konto bei Lifesum beendet wird. In einigen Fällen
        kann Lifesum jedoch die Verarbeitung einiger personenbezogener Daten für
        bestimmte Teile der Lifesum-Dienste einstellen, ohne dass Sie die
        Nutzung der gesamten Lifesum-Dienste beenden müssen. Bitte beachten Sie
        hierzu die Abschnitte „Datenverarbeitung ist erforderlich, um Dienste
        anzubieten“ und „Opt-out im Bezug auf Werbung“ weiter oben.
      </p>

      <h3>Erhaltung und Speicherung Ihrer personenbezogenen Daten</h3>
      <p>
        Sofern Sie Ihr Konto nicht löschen, keine Berichtigung oder Löschung der
        relevanten personenbezogenen Daten beantragen oder die Verarbeitung im
        Zusammenhang mit Marketing ablehnen, speichern und verarbeiten wir Ihre
        personenbezogenen Daten im Allgemeinen, solange Sie ein registrierter
        Benutzer unserer Dienste sind und ein Benutzerkonto haben. Wir werden
        die Speicherung und Verarbeitung Ihrer personenbezogenen Daten
        einstellen, sobald Ihr Benutzerkonto / Ihre Registrierung beendet wird,
        Sie eine Berichtigung oder Löschung beantragen oder die Teilnahme an
        Marketing deaktivieren - es sei denn, wir müssen die entsprechenden
        personenbezogenen Daten für die entsprechenden Zwecke für einen längeren
        Zeitraum speichern oder verarbeiten (z.B. für Buchhaltungszwecke).
      </p>
      <p>
        Darüber hinaus überprüfen wir regelmäßig die Notwendigkeit, Ihre
        persönlichen Daten zu speichern oder zu löschen, falls Ihr Konto über
        einen längeren Zeitraum inaktiv war. Dies geschieht normalerweise nach
        einem Zeitraum von fünf (5) Jahren, wenn Sie die Lifesum Dienste
        dauerhaft nicht aktiv genutzt haben. Diese regelmäßigen Überprüfungen
        werden durchgeführt, um sicherzustellen, dass wir Ihre persönlichen
        Daten nicht länger als nötig speichern. Eine Nutzung des Kontos nach
        Inaktivitätsphasen (die gemäß unserer Erfahrung bei einigen Benutzern
        häufig vorkommen) können Sie Ihr Konto jedoch wieder verwenden.
      </p>

      <h3>Datenübermittlung</h3>
      <p>
        Von Ihnen erhobene personenbezogene Daten werden an Dienstleister, die
        im Auftrag von Lifesum personenbezogene Daten verarbeiten, z.B.
        Server-Hosting-Anbieter, Speicherplatzanbieter, Unternehmen zur
        Kontrolle von Systemleistung und Umsatzentwicklung,
        Kundenbetreuungssysteme und Zahlungsdienstleister, weitergegeben. Diese
        Dienstleister werden als Auftragsverarbeiter Ihrer personenbezogenen
        Daten betrachtet.
      </p>
      <p>
        Gelegentlich werden Teile Ihrer personenbezogenen Daten an
        Auftragsverarbeiter (s.o.) übermittelt, die Ihren Sitz in den USA oder
        anderen Staaten (einige außerhalb der EWR) haben und von solchen
        verarbeitet. Lifesum wird immer Vorsichtsmaßnahmen ergreifen, um Ihre
        Daten vor unbefugter Offenlegung zu schützen. Wir werden Ihre
        personenbezogenen Daten ggf. auch übermitteln, falls unser Geschäft
        (oder einen Teil davon) verkauft wird, z.B. als Teil einer Verschmelzung
        oder Übernahme. Für den Fall einer Übermittlung von Daten an Dritte, die
        sich außerhalb der EU oder der EWR befinden und kein ausreichendes
        Datenschutzniveau anbieten, wird Lifesum die Musterklauseln der EU
        Kommission anwenden und/oder verbindliche Unternehmensregeln oder
        ähnliche Mittel, um die Unversehrtheit und Sicherheit der Daten zu
        schützen.
      </p>
      <p>
        Keinesfalls übermittelt Lifesum personenbezogene Daten an Dritte unter
        Gewährung eines Rechts zur Nutzung dieser Daten für andere Zwecke als im
        Auftrag von Lifesum.
      </p>
      <p>
        Lifesum kann darüber hinaus Ihre personenbezogenen Daten zur Einhaltung
        von gesetzlichen oder regulatorische Pflichten offenlegen, soweit wir
        Grund zu der Annahme haben, dass dies das Gesetz, eine Verordnung oder
        andere Rechtsvorschriften verlangen, oder um Lifesum, seine
        Geschäftspartner oder die Rechte und Interessen von Nutzern zu schützen
        und zu verteidigen, wobei jedenfalls die einschlägigen
        Datenschutzvorschriften eingehalten werden.
      </p>

      <h3>Datenübertragbarkeit</h3>
      <p>
        Sie sind berechtigt die personenbezogenen Daten, die Sie Lifesum
        bereitgestellt haben, gemäß den einschlägigen Datenschutzvorschriften zu
        erhalten, soweit ein solcher Antrag nicht die Rechte und Freiheiten
        anderer beeinträchtigt.
      </p>

      <h3>Beschwerden</h3>
      <p>
        Sollten Sie Fragen oder Beschwerden hinsichtlich unserer Verarbeitung
        Ihrer personenbezogenen Daten haben, können Sie uns unter
        https://lifesum.com/contact kontaktieren. Sie haben außerdem das Recht
        eine Beschwerde bei der Aufsichtsbehörde einzureichen.
      </p>

      <h3>Sicherheit der von uns verarbeiteten personenbezogenen Daten</h3>
      <p>
        Die Sicherheit und Unversehrtheit Ihrer personenbezogenen Daten ist uns
        wichtig. Über die Beachtung der einschlägig anwendbaren
        Datenschutzvorschriften hinaus nutzen wir die anerkannten
        Industriestandards, Technologien und Verfahren, wie z.B. Firewalls,
        Sicherheitssoftware etc., um die Unversehrtheit Ihrer personenbezogenen
        Daten zu schützen und um unbefugten Zugang zu diesen zu verhindern.
        Allerdings kann kein System 100-prozentige Sicherheit bieten. Trotz
        unseren Bemühungen besteht immer ein Risiko, dass Unbefugte sich Zugang
        zu Ihren personenbezogenen Daten verschaffen. Indem Sie unsere Dienste
        nutzen, nehmen Sie dieses Risiko auf sich. Wir fordern Sie zudem auf,
        ein einmaliges und starkes Passwort zu nutzen, um Ihr Konto bei den
        Lifesum Diensten zu schützen und dieses Passwort vor unbefugtem Zugriff
        zu schützen. Sie sollten außerdem den Zugang zu Ihrem Rechner und
        Browser begrenzen und sich ausloggen, nachdem Sie die Lifesum Dienste
        genutzt haben.
      </p>

      <h3>Kinder</h3>
      <p>
        Sollten Sie jünger als 13 Jahre sein ist es Ihnen nicht erlaubt,
        personenbezogene Daten unter Nutzung unserer Dienste anzugeben. Überdies
        fordern wir Eltern und Erziehungsberechtigte dazu auf, die
        Internetnutzung ihrer Kinder zu überwachen und uns bei der Durchsetzung
        unserer Datenschutzerklärung zu unterstützen, indem sie ihre Kinder
        anweisen, niemals ohne ihre Erlaubnis personenbezogene Daten über
        unseren Dienst anzugeben. Wenn Sie davon erfahren, dass ein Kind unter
        13 Jahren personenbezogene Daten an uns übermittelt hat, kontaktierten
        Sie uns bitte unter https://lifesum.com/contact.
      </p>

      <h3>Änderungen unserer Datenschutzerklärung</h3>
      <p>
        Von Zeit zu Zeit kann es notwendig werden, Änderungen an dieser
        Datenschutzerklärung vorzunehmen. Wir behalten uns daher vor, jederzeit
        Aktualisierungen und/oder Änderungen an dieser Datenschutzerklärung
        vorzunehmen, indem wir Ihnen diese mitteilen. Bitte prüfen Sie diese
        Datenschutzerklärung regelmäßig, vor allem bevor Sie bei uns ein Konto
        anmelden. Das Datum der letzten Änderung steht am Ende dieser
        Datenschutzerklärung.
      </p>

      <h3>Kontakt</h3>
      <p>
        Wir werden Sie per E-Mail und durch Mitteilungen, die auf Ihrem mobilen
        Endgerät erscheinen, kontaktieren. Wenn Sie keine Mitteilungen auf Ihrem
        mobilen Endgerät wünschen, können Sie diesen Dienst jederzeit
        abschalten. Es wird darauf hingewiesen, dass Sie weiterhin Antworten auf
        Fragen, die Sie an die Kundenbetreuung gestellt haben, per E-Mail
        erhalten, wenn Sie sich aus unserer E-Mail Verteilerliste austragen.
      </p>
      <p>
        Wir freuen uns auf Ihr Feedback zu unseren Diensten. Sollten Sie Fragen
        oder Anregungen in Bezug auf unsere Datenschutzerklärung haben,
        kontaktieren Sie uns bitte unter https://lifesum.com/contact.
      </p>

      <p>
        <small>Letzte Aktualisierung: 29.06.2018</small>
      </p>

      <h2>
        Lifesum Allgemeine Geschäftsbedingungen <br />
        <small>Letzte Aktualisierung: 29.06.2018</small>
      </h2>

      <p>
        Wir möchten uns bei Ihnen dafür bedanken, dass Sie unsere Produkte und
        Dienstleistungen (der/die „Dienst/e“) nutzen. Indem Sie Mitglied werden
        oder unsere Dienste in Anspruch nehmen, erklären Sie sich mit der
        Geltung dieser Allgemeinen Geschäftsbedingungen („AGB“) einverstanden.
        Es ist daher von hoher Bedeutung, dass Sie diese AGB sorgfältig lesen.
        Wenn Sie mit diesen AGB nicht einverstanden sind, sollten Sie sich nicht
        bei Lifesum anmelden.
      </p>

      <h3>Über Lifesum</h3>
      <p>
        Lifesum ist ein von der Lifesum AB entwickelter und bereitgestellter
        Dienst. Der Dienst ist unter anderem auf lifesum.com, in dem iPhone App
        Store unter „Lifesum“ und in dem Google Play Store unter „Lifesum“
        online erhältlich. Der von Lifesum verfolgte Zweck ist es, unseren
        Nutzern bei der Erfassung ihrer Ess- und Trainingsgewohnheiten
        behilflich zu sein und die Entwicklung Ihrer Fortschritte in Sachen
        Gesundheit, Gewicht und Kondition zu tracken.
      </p>

      <h3>Nutzungsbedingungen für unsere Dienste</h3>
      <p>
        Um unsere Dienste zu nutzen, müssen Sie einige einfachen Regeln
        befolgen. Der Dienst steht nur zur privaten Nutzung bereit und ist für
        gewerbliche Nutzung nicht bestimmt. Unterlassen Sie die Zweckentfremdung
        der Dienste, damit weder Lifesum noch andere in irgendeiner Weise zu
        Schaden kommt. Sie dürfen die Dienste nur so nutzen, wie es das Gesetz
        und diese AGB erlauben. Indem Sie unsere Dienste nutzen, erklären Sie
        sich damit einverstanden, dass:
      </p>
      <ul>
        <li>
          alle von Ihnen angegebenen personenbezogenen Daten richtig und aktuell
          sind.
        </li>
        <li>
          Sie für die Aktivitäten innerhalb Ihres Kontos und alle Inhalte, die
          Sie unter Ihrem Lifesum Konto hochladen und/oder erstellen
          („Benutzermaterial“) allein verantwortlich sind.
        </li>
        <li>
          Lifesum die Inhalte des Dienstes nicht überwacht, aber jederzeit nach
          eigenem alleinigem Ermessen Benutzermaterial aus dem Dienst und/oder
          Ihrem Konto entfernen sowie Ihr Konto und Ihre Mitgliedschaft beenden
          kann.
        </li>
        <li>
          Ihre Mitgliedschaft bei Lifesum, einschließlich Ihrer E-Mails und
          Ihrem Passwort, sich auf Ihre Person bezieht und nicht auf einen
          anderen übertragen oder von anderen genutzt werden darf. Sie sind
          dafür verantwortlich, Ihre Zugangsdaten sicher zu verwahren. Lifesum
          ist in keiner Weise für etwaige Schäden verantwortlich, die durch
          unbefugten Zugang zu Ihrem Konto oder Nutzung Ihrer Zugangsdaten
          entstehen. Sollten Sie Kenntnis oder den Verdacht einer unbefugten
          Nutzung Ihres Kontos haben, sind Sie verpflichtet die Lifesum
          Kundenbetreuung unverzüglich zu informieren. Kontaktinformationen
          finden Sie am Ende dieses Dokuments.
        </li>
        <li>
          Lifesum nicht zur Nutzung durch Personen unter 13 Jahren bestimmt ist.
          Sie müssen mindesten 13 Jahre alt sein, um Lifesum zu nutzen.
        </li>
        <li>
          die Verletzung dieser AGB die sofortige Kündigung Ihres Kontos und
          Abonnements nach sich ziehen wird. Wenn Sie diese AGB verletzen,
          werden Sie keine Erstattung erhalten.
        </li>
        <li>
          gewerbliche Angebote, Werbung und/oder Hinweise darauf (z.B. Links),
          wo gewerbliche Angebote zu finden sind, unter Nutzung unserer Dienste
          verboten sind.
        </li>
        <li>
          Beiträge zur Propaganda, religiöse und/oder politische
          Meinungsbeiträge oder Beiträge, die Informationen enthalten, die in
          irgendeiner Weise eine Verleitung zum Rassenhass, Kinderpornografie
          oder Pornografie enthalten oder eine solche betreffen, unter Nutzung
          unserer Dienste verboten sind. Außerdem ist es verboten, unter Nutzung
          unserer Dienste andere zu diffamieren, belästigen oder zu beleidigen.
        </li>
        <li>
          Sie bei Kritik oder Feedback an Lifesum oder unseren Diensten zuerst
          Lifesum kontaktieren, um uns dabei zu helfen unsere Dienste zu
          verbessern.
        </li>
        <li>
          Sie keine Dateien übertragen und/oder verbreiten dürfen, die Lifesum
          oder die Rechner oder das Eigentum anderer schädigen können (z.B.
          Viren und Trojaner).
        </li>
        <li>
          Sie die persönlichen Informationen anderer nicht ohne deren Erlaubnis
          teilen dürfen.
        </li>
      </ul>

      <h3>Ihr Konto</h3>
      <p>
        Sie können Ihr Konto jederzeit kündigen/schließen. Beachten Sie bitte,
        dass die Deinstallation Ihrer mobilen Anwendung oder das Schließen Ihres
        Kontos nicht automatisch auch das Abonnement beendet – Sie müssen das
        Abonnement aktiv kündigen. Bitte beachten Sie ferner, dass Sie das
        Abonnement über die Dienste App Store, Google Play Store oder ähnliche
        Dienstleister kündigen müssen, wenn Sie Lifesum über einen solchen
        Dienst abonniert haben. Um herauszufinden, wie Sie das Abonnement
        und/oder Ihr Konto beenden können, folgen Sie bitte der Anleitung in der
        App oder auf der Webseite. Besondere Bedingungen gelten für Lifesum
        Premium.
      </p>

      <h3>Gesundheits- und Ernährungshinweise</h3>
      <p>
        Sie sind selbst für Ihre Gesundheit verantwortlich. Lifesum ist keine
        medizinische Einrichtung und wir bieten keine medizinischen Ratschläge
        oder Diagnosen. Der Zweck der Dienste ist es lediglich, den Nutzern
        dabei behilflich zu sein, zu erfassen was sie essen, wie sie trainieren
        und ihre Fortschritte bezüglich Gesundheit, Gewicht und Kondition zu
        tracken. Informationen, die über die Dienste und von unseren Partnern
        und verbundenen Unternehmen bereitgestellt werden, sollen lediglich für
        Freizeit- und Bildungszwecke genutzt werden. Beraten Sie sich stets mit
        Ihrem Arzt bevor Sie eine Diät oder ein Fitnessprogramm beginnen oder
        wenn Sie Schmerzen oder Beschwerden haben. Lifesum kann keine Ergebnisse
        oder Verbesserungen in Bezug auf Gesundheit, Gewicht und/oder Kondition
        garantieren. Unsere Dienste sind nur an gesunde Erwachsene gerichtet,
        nutzen Sie unsere Dienste bitte nicht, wenn Sie an einer Krankheit
        leiden oder leiden könnten, die durch eine Diät oder Training
        verschlechtert werden könnte. Nährwertangaben in unserer Datenbank
        wurden nicht durch Lifesum geprüft, untersucht oder bewertet. Lifesum
        steht nicht dafür ein, dass die Ernährungshinweise in unserer Datenbank
        richtig, verlässlich oder vollständig sind. Lifesum haftet nicht für
        Personenschäden oder andere Schäden, die ggf. direkt oder indirekt auf
        den Gebrauch oder Missbrauch der Dienste zurückzuführen sind.
      </p>

      <h3>Lifesum Premium</h3>
      <p>
        Dieser Abschnitt findet nur Anwendung, wenn Sie Lifesum Premium oder
        andere kostenpflichtige Produkte gekauft und/oder abonniert haben. Indem
        Sie die Abonnementgebühr zahlen, erhalten Sie Zugang zu Lifesum Premium
        während der Abonnementlaufzeit unter den folgenden Bedingungen.
      </p>
      <p>Alle Lifesum Premium Abonnements werden im Voraus bezahlt.</p>
      <p>
        Sie können jederzeit Ihre Mitgliedschaft beenden, in dem Fall dauert
        Ihre Mitgliedschaft noch so lange wie die Abonnement-Bezugsdauer, die
        Sie bereits bezahlt haben. Soweit Sie ein Lifesum Abonnement über einen
        Dienst wie App Store, Google Play Store oder einen anderen solchen
        Dienstleister bezogen haben, können Sie Ihr Abonnement nur über die
        Nutzung des gleichen Dienstes kündigen. Abonnementgebühren sind auf der
        Lifesum Webseite (www.lifesum.com) ersichtlich sowie in der mobilen
        Anwendung. Lifesum akzeptiert mehrere Zahlungsmittel, z.B. PayPal, Apple
        iTunes, Google Play und Kreditkartenzahlung. Es gelten möglicherweise
        besondere Bedingungen. Lifesum behält sich vor, die Abonnementgebühren
        gelegentlich zu ändern.
      </p>
      <HashAnchor use="p" id="refunds">
        Hiermit erteilen Sie Ihre Einwilligung zur Aufnahme der Nutzung der
        Dienste unverzüglich mit der Anmeldung für Lifesum Premium oder andere
        kostenpflichtige Produkte. Daher beginnt die 14-tägige Frist zum
        Widerruf des Vertrages mit Lifesum ab dem Datum, an dem Sie die
        Bestätigung Ihres Abonnements per E-Mail erhalten, auch wenn Sie die
        Nutzung der Dienste nicht innerhalb dieser Frist aufnehmen. Um Ihr
        Widerrufsrecht auszuüben, müssen Sie Lifesum eine E-Mail schicken
        (unsere Kontaktinformationen finden Sie am Ende dieses Dokuments). Im
        Voraus bezahlte Gebühren werden Ihnen innerhalb von 30 Tagen
        zurückerstattet. Alle Zahlungen, die über Apple laufen, z.B. Käufe
        innerhalb von Apps, können nur von Apple mit Apples Einwilligung
        erstattet werden. Sollten Sie Apple kontaktieren wollen, klicken Sie
        bitte <a href="http://support.apple.com/kb/ht4098">hier</a>.
        Zahlungsverzug wird nicht als die Beendigung eines Lifesum Premium
        Abonnements gewertet.
      </HashAnchor>

      <h3>Geistiges Eigentum</h3>
      <p>
        Alle Rechte innerhalb und an den Diensten, einschließlich aller
        Schutzmarken, Dienstleistungsmarken, Handelsnamen und urheberrechtlich
        geschützten Inhalten (zusammen „geistiges Eigentum“), die im Rahmen des
        Dienstes dargestellt werden, sind das Eigentum von Lifesum und/oder
        Dritter. Hiermit willigen Sie darin ein, das geistige Eigentum für keine
        anderen Zwecke außer für Ihre Nutzung des Dienstes zu nutzen, soweit
        nicht durch einschlägiges zwingendes Recht anderweitig vorgeschrieben.
      </p>
      <p>
        Indem Sie Benutzermaterial an Lifesum übermitteln, übernehmen Sie Gewähr
        und versichern, dass Sie das Urheberrecht, die Schutzmarke und/oder
        andere Schutzrechte an Ihren Inhalten innehaben. Sie erklären sich damit
        einverstanden, an Lifesum eine nicht-ausschließliche, übertragbare,
        unterlizenzierbare, gebührenfreie, weltweite Lizenz zu erteilen, das
        Benutzermaterial in dem Umfang zu nutzen, der erforderlich ist damit
        Lifesum den Dienst betreiben und aufrechterhalten kann. Diese Lizenz
        bleibt gültig bis das jeweilige Benutzermaterial vom Dienst Ihrerseits
        oder durch Lifesum gemäß diesen AGB gelöscht wird.
      </p>

      <h3>Haftungsausschluss und Haftungsbeschränkung</h3>
      <p>
        Sie nutzen den Dienst auf eigene Gefahr. Der Dienst wird im
        ”Ist-Zustand” bereitgestellt, ohne irgendeine Art von Gewährleistung.
        Lifesum übernimmt keine Gewähr dafür, dass der Dienst und dessen
        Verfügbarkeit ohne Unterbrechungen und fehlerfrei bleibt. Lifesum
        übernimmt keine Verantwortung für Fehler oder Unterlassungen in Bezug
        auf die Informationen, Software oder anderen Unterlagen, einschließlich
        Benutzermaterial, auf das Bezug genommen wird oder das verlinkt wird.
        Bezugnahmen oder Links auf Webseiten von Drittanbietern werden im
        ”Ist-Zustand” bereitgestellt, ohne jegliche Gewährleistung (weder
        ausdrücklich noch konkludent).
      </p>
      <p>
        Lifesum wird nicht für mittelbare oder Folgeschäden haften, außer in
        Fällen von vorsätzlichem Fehlverhalten oder grober Fahrlässigkeit. In
        dem gesetzlich gestatteten Umfang wird die kumulierte Haftung von
        Lifesum für unmittelbare Schäden auf die geringste der folgenden Summen
        beschränkt: (i) die vom Nutzer gezahlten Mitgliedsbeiträge; (ii) die vom
        Nutzer im letzten Kalenderjahr gezahlten Mitgliedsbeiträge; oder (iii) 5
        000 SEK.
      </p>

      <h3>Sonstiges</h3>
      <p>
        Es wird klargestellt, dass Lifesum keine Verpflichtung zur Überwachung
        der Inhalte des Benutzermaterials übernimmt.
      </p>
      <p>
        Sie sind ohne die vorherige schriftliche Einwilligung von Lifesum nicht
        berechtigt Ihre Rechte und/oder Pflichten nach Maßgabe dieser AGB oder
        die Nutzung des Dienstes an einen Dritten zu übertragen. Lifesum ist
        berechtigt, seine Rechte und/oder Pflichten nach Maßgabe dieser AGB zu
        übertragen.
      </p>
      <p>
        Lifesum behält sich vor, jederzeit aus beliebigen Gründen einer Person
        den Dienst zu verweigern. Lifesum wird diese AGB möglicherweise von Zeit
        zu Zeit überarbeiten. Die aktuellste Version wird immer auf Lifesums
        Webseite (www.lifesum.com) gepostet sein. Sämtliche wesentlichen
        Änderungen werden zwischen Ihnen und Lifesum wirksam, nachdem Sie solche
        Änderungen angenommen haben (z.B. indem Sie die Dienste nutzen, nachdem
        Sie auf die Änderung hingewiesen wurden oder indem Sie Ihr Abonnement
        erneuern).
      </p>

      <h3>Anwendbare Rechtsordnung und Streitbeilegung</h3>
      <p>
        Diese AGB und die Nutzung der Dienste unterliegen schwedischem Recht mit
        Ausnahme der kollisionsrechtlichen Grundsätze. Alle Ansprüche, die sich
        aus diesen AGB oder in Zusammenhang mit diesen AGB oder dem Dienst
        ergeben, werden in den schwedischen öffentlichen Gerichten geklärt,
        wobei das Bezirksgericht in Stockholm das Gericht erster Instanz ist.
      </p>

      <h3>Kontaktangaben</h3>
      <p>
        Sie können Lifesum bezüglich weiterer Informationen, Fragen oder Support
        kontaktieren. Die Kundenbetreuung kann entsprechend den Angaben auf der
        Webseite oder in den Anwendungen erreicht werden. Die verfügbaren
        Support-Kanäle können gelegentlich wechseln.
      </p>

      <h4>Kontaktangaben</h4>
      <dl>
        <dt>Firmenbezeichnung</dt>
        <dd>Lifesum AB</dd>

        <dt>Organisationsnummer</dt>
        <dd>556729-2841</dd>

        <dt>Adresse</dt>
        <dd>
          Repslagargatan 17B, <br />
          118 46 Stockholm, Schweden
        </dd>

        <dt>E-mail</dt>
        <dd>
          {mobile && 'contact@lifesum.com'}
          {!mobile && (
            <a href="mailto:contact@lifesum.com">contact@lifesum.com</a>
          )}
        </dd>
      </dl>
    </>
  )
}

PrivacyPolicyDE.propTypes = {
  mobile: PropTypes.bool,
}

export default PrivacyPolicyDE
